import { render, staticRenderFns } from "./ModalOtpWidget.vue?vue&type=template&id=1079a036&scoped=true&"
import script from "./ModalOtpWidget.vue?vue&type=script&lang=js&"
export * from "./ModalOtpWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079a036",
  null
  
)

export default component.exports